import { lazyForPaint } from 'react-loosely-lazy';

export const DashboardListLazy = lazyForPaint(
	() =>
		import(/* webpackChunkName: "async-jsm-avp-experience-dashbaord-list-defer" */ './main').then(
			({ DashboardList }) => DashboardList,
		),
	{ ssr: false },
);
